// extracted by mini-css-extract-plugin
module.exports = {"card":"column-card-module--card--3ZOpg","imageWrapper":"column-card-module--imageWrapper--1fVA9"};